var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":("company/" + _vm.id),"title":this.name}},[_vm._v(_vm._s(this.name))])}
var staticRenderFns = []

export { render, staticRenderFns }